import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["projectFilter"];

  connect() {
    this.rows = Array.from(this.element.querySelectorAll("tbody tr"));
    this.projectFilterTarget.addEventListener("change", () => this.filter());
  }

  filter() {
    const project = this.projectFilterTarget.value.toLowerCase();

    this.rows.forEach(row => {
      const rowProject = row.children[1].textContent.toLowerCase(); // second column = Project
      if (!project || rowProject === project) {
        row.style.display = "";
      } else {
        row.style.display = "none";
      }
    });
  }
}
